import React from 'react';
import { useLoading } from "../../../../util/LoadingProvider";
import apiHelper from "../../../../util/ApiHelper";
import { Controller, useForm, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import * as yup from "yup";
import Box from "@material-ui/core/Box";
import {
	Button,
	Checkbox,
	FormControlLabel,
	FormGroup,
	FormHelperText,
	makeStyles,
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import UploadImage from "../../UploadImage";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { toast } from "react-toastify";
import { useHistory } from "react-router";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import editorConfiguration from "../../../../util/EditorConfiguration";
import styled from "styled-components";
import ProductOptionSections from "./ProductOption";
import Autocomplete from "@material-ui/lab/Autocomplete";
import IconButton from "@material-ui/core/IconButton";
import { Cancel } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  tabpanel: {
    background: "#FFFFFF",
  },
  textInput: {
    backgroundColor: "white",
    width: "100%",
    marginBottom: "12px",

    "& input": {
      fontSize: "14px",
    },
  },
  content: {
    "& .ck-editor__editable_inline": {
      minHeight: "200px",
    },
  },
  buttonGroup: {
    marginTop: "20px",
    textAlign: "right",
    "& button": {
      color: "#306F9D",
      fontSize: "13px",
      textTransform: "inherit",
    },
  },
  box: {
    padding: 0,
  },
  innerBox: {
    background: "#ffffff",
    padding: theme.spacing(3),
    marginBottom: theme.spacing(4),
  },
  sectionText: {
    fontSize: "13px",
    fontWeight: 700,
    paddingLeft: "4px",
  },
  imageGallery: {
    border: "1px solid #CCCCCC",
    minHeight: "160px",
    borderRadius: "3px",
    position: "relative",
  },
  imageGalleryControl: {
    position: "relative",
    width: "100%",
    display: "flex",
    height: "40px",
    bottom: "0",
    borderTop: "1px solid #CCCCCC",
    padding: "5px",
  },
  imageGalleryBlk: {
    minHeight: "120px",
    padding: "5px",
  },
  imgPreview: {
    maxWidth: "200px",
    margin: "10px",
    display: "inline-flex",
    position: "relative",
    verticalAlign: "top",
    "& img": {
      width: "100%",
      height: "auto",
    },
    "& button": {
      position: "absolute",
      top: "-10px",
      right: "-10px",
      zIndex: "10",
      display: "block",
      color: "rgba(48, 111, 157, 0.8)",
      background: "white",
      padding: 0,
      transition: "200ms all ease-out",
      "&:hover": {
        color: "rgba(48, 111, 157, 1)",
        background: "white",
      },
    },
  },
  permalink: {
    paddingLeft: "5px",
    fontSize: "13px",
    display: "flex",
    alignItems: "center",
    "& .permalink": {
      fontWeight: 700,
    },
  },
  input: {
    width: "100%",
    marginTop: "20px",
    marginLeft: "10px",
    "& button": {
      fontSize: "13px",
      lineHeight: "15px",
      width: "25%",
    },
  },
  imageGallery: {
    border: "1px solid #CCCCCC",
    minHeight: "160px",
    borderRadius: "3px",
    position: "relative",
  },
  imageGalleryControl: {
    position: "relative",
    width: "100%",
    display: "flex",
    height: "40px",
    bottom: "0",
    borderTop: "1px solid #CCCCCC",
    padding: "5px",
  },
  imageGalleryBlk: {
    minHeight: "120px",
    padding: "5px",
  },
  orderLimitControl: {
	display: "flex",
	alignItems: "flex-start",
	"& .MuiFormControlLabel-root": {
		marginLeft: "16px",
		whiteSpace: "nowrap",
	},
	"& input::-webkit-outer-spin-button": {
		display: "none",
	},
	"& input::-webkit-inner-spin-button": {
		display: "none",
	},
	"& .MuiFormHelperText-root": {
		padding: "0px 16px",
		color: "#f44336",
	},
},
}));

const defaultFormValues = {
  isMailDelivery: true,
  localizations: {
    en: {
      introduction: "",
      subtitle: "",
      title: ""
    },
    tc: {
      introduction: "",
      subtitle: "",
      title: ""
    },
  },
  status: "ACTIVE",
  image: {
    image: []
  },
  options: {
    "nameTc": "",
    "nameEn": "",
    "optionDtl": [
        {
            "optionTc": null,
            "optionEn": null,
            "orgPrice": null,
            "price": null,
            "quantitySold": null,
            "quantityStock": null,
            "outOfStock": false
        }
    ]
  },
  hasOrderLimit: false,
  orderLimit: null,
  type:""
};

const PriceTag = styled.span`
  color: #CCCCCC;
  transform: scale(0.8);
`;

const schema = yup.object().shape({
  localizations: yup.object().shape({
    en: yup.object().shape({
      title: yup.string().required("Title is required."),
    }),
    tc: yup.object().shape({
      title: yup.string().required("Title is required."),
    }),
}),
  hasOrderLimit: yup.boolean().when("orderLimit", {
	is: (orderLimit) => orderLimit > 0,
	then: yup.boolean().equals([true], "Order limit should be checked."),
  }),
  orderLimit: yup.mixed().when("hasOrderLimit", {
  is: (hasOrderLimit, orderLimit) => hasOrderLimit === true && (isNaN(orderLimit) || orderLimit <= 0),
	then: yup
		.mixed()
    .test(
      "required",
      "Order limit is required.",
      (value) => !isNaN(value) && value > 0
    ).nullable(),
	otherwise: yup.string().nullable(),
  }),
}, [["hasOrderLimit", "orderLimit"]]);

function TabPanel(props) {
  const classes = useStyles();
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      <Box p={3} className={classes.box}>
        {children}
      </Box>
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    "aria-controls": `nav-tabpanel-${index}`,
  };
}

const ProductEditPage = ({ match, disabled }) => {
  const { id } = match.params;
  const { setLoading } = useLoading();
  const history = useHistory();
  const classes = useStyles();
  const [activeTab, setActiveTab] = React.useState(0);
  const [categoryList, setCategoryList] = React.useState([]);
  const [defaultValues, setDefaultValues] = React.useState(defaultFormValues);
  const [productTagList, setProductTagList] = React.useState([]);
  const [options, setOptions] = React.useState("");

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const {
    control,
    handleSubmit,
    watch,
    getValues,
    reset,
    setValue,
    formState,
  } = useForm({
    defaultValues: React.useMemo(() => defaultValues, [defaultValues]),
    resolver: yupResolver(schema),
  });

  const productTag = useWatch({
    control,
    name: "productTabIds",
  });

  const uploadFile = async (file) => {
    try {
      setLoading(true);
      const result = await apiHelper.hkiff.uploadHKIFFFile(file, "PRODUCT");
      console.log(result.data.url);
      return result.data.url;
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleFileUpload = async (event) => {
    console.log(event);
    for (var i = 0, files = event.target.files; i < files.length; i++) {
      const file = event.target.files[i];
      if (file) {
        const url = await uploadFile(file);
        const galleryValue = getValues("image.image");
        const newGalleryValue = [...galleryValue, url];
        setValue(`image.image`, newGalleryValue, { shouldDirty: true });
      }
    }
  };

  const removeImgFromSlides = (url) => {
    const galleryValue = getValues("image.image");

    const newGalleryValue = galleryValue.filter((item) => item !== url);

    setValue(`image.image`, newGalleryValue, { shouldDirty: true });
  };

  const getProductCategoryList = React.useCallback(async () => {
    try {
      setLoading(true);
      const result = await apiHelper.hkiff.getProductCategories(
        null,
        0,
        0,
        9999999,
        ''
      );
      setCategoryList(result.data.content);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  }, [setLoading])

  const getAllProductTags = async () => {
    try {
      setLoading(true);
      const result = await apiHelper.hkiff.getProductTags({
        pageSize: 99999999,
      });
      const resultList = result.data.content.map((item) => ({
        label: item.localizations.en.name,
        id: item.id,
      }));
      setProductTagList(resultList);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const getProductById = React.useCallback(async () => {
    try {
      setLoading(true);
      const res = await apiHelper.hkiff.getProductById(id);
      res.data.productTabIds = res.data.productTabs.map((item) => (item.tab.id));
      setDefaultValues(res.data);
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false);
    }
  }, [id])

  const onSubmit = async (data) => {
    data.orderLimit = data.orderLimit === '' ? null: data.orderLimit;
    if (id !== 'new') {
      try {
        setLoading(true)
        if(!data.options.nameEn && !data.options.nameTc) {
          data.options.nameEn = "default";
          data.options.nameTc = "default";
        }

        //out of stock flag should be checked when stock is <= 0
        if (data.options.optionDtl.length > 0) {
          data.options.optionDtl.map((option) => {
            if (option.quantityStock <= 0 && option.outOfStock === false) {
              option.outOfStock = true;
            }
           })
        }

        await apiHelper.hkiff.updateProductById(id, data);
        await getProductById()
        toast.success("Product updated successfully.");
      } catch (e) {
        console.log(e)
      } finally {
        setLoading(false)
      }
    } else {
      try {
        setLoading(true)
        if(!data.options.nameEn && !data.options.nameTc) {
          data.options.nameEn = "default";
          data.options.nameTc = "default";
        }
        // set a default type
        if (!data.type || data.type === "None") {
					data.type =
						categoryList.find((cat) => cat.type === "publications")?.type ||
						"publications";
				}
        const res = await apiHelper.hkiff.createProduct(data);
        toast.success("Product created successfully.");
        history.push(`/hkiff/eshop/product/${res.data.id}`)
      } catch (e) {
        console.log(e)
      } finally {
        setLoading(false)
      }
    }
  }

  React.useEffect(() => {
    async function init() {
      await getAllProductTags();
      await getProductCategoryList();
      if (id && id !== 'new') {
        await getProductById()
      }
    }

    init()
  }, [id])

  React.useEffect(() => {
    reset(defaultValues)
  }, [reset, defaultValues])

  console.log({ defaultValues })

  return (
    <div className={classes.content}>
      <Typography variant="h4" gutterBottom>
        Product > {id === 'new' ? 'Add New Product' : 'Edit Product'}
      </Typography>
      <Tabs
        value={activeTab}
        onChange={handleChange}
        aria-label="nav tabs example"
        TabIndicatorProps={{ style: { top: "0", background: "#306F9D" } }}
      >
        <Tab
          label="English"
          {...a11yProps(0)}
        />
        <Tab
          label="繁體中文"
          {...a11yProps(1)}
        />
      </Tabs>
      <form onSubmit={handleSubmit(onSubmit)}>
        <fieldset disabled={disabled} className="fieldset">
          <TabPanel value={activeTab} index={0}>
            <Box className={classes.innerBox} style={{ paddingTop: 32, marginBottom: 30 }}>
              <Grid container direction="vertical" spacing={3}>
                <Grid item xs={12}>
                  <Controller
                    name={`localizations.en.title`}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        label="Title"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        defaultValue={field.value ?? ''}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Box
                    fontWeight={900}
                    fontSize={13}
                    mb={2}
                    mt={2}
                    width="100%"
                  >
                    <Typography variant="p">Content</Typography>
                  </Box>
                  <Controller
                    name="localizations.en.introduction"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <CKEditor
                        editor={Editor}
                        config={editorConfiguration}
                        data={field.value || ""}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          field.onChange(data);
                        }}
                        disabled={disabled}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>
          </TabPanel>
          <TabPanel value={activeTab} index={1}>
          <Box className={classes.innerBox} style={{ paddingTop: 32, marginBottom: 30 }}>
              <Grid container direction="vertical" spacing={3}>
                <Grid item xs={12}>
                  <Controller
                    name={`localizations.tc.title`}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        label="Title"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        defaultValue={field.value}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Box
                    fontWeight={900}
                    fontSize={13}
                    mb={2}
                    mt={2}
                    width="100%"
                  >
                    <Typography variant="p">Content</Typography>
                  </Box>
                  <Controller
                    name="localizations.tc.introduction"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <CKEditor
                        editor={Editor}
                        config={editorConfiguration}
                        data={field.value || ""}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          field.onChange(data);
                        }}
                        disabled={disabled}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>
          </TabPanel>

          <Box className={classes.innerBox} style={{ paddingTop: 10, marginBottom: 0 }} direction="column" spacing={3}>
            <Grid container item xs={12}>
              <Grid item xs={12}>
                <Box mb={2}>
                  <strong className={classes.sectionText}>
                    Product Details
                  </strong>
                </Box>
              </Grid>
            </Grid>
            <Grid container item xs={12}>
              <Grid item xs={6}>
                <FormControl variant="outlined" margin="dense" className={classes.formControl}
                style={{ width: "100%" }}>
                <InputLabel htmlFor="outlined-age-native-simple">Select Category</InputLabel>
                <Controller
                  defaultValue={defaultValues.type} 
                  name={`type`}
                  control={control}
                  render={({ field, fieldState: { error } }) => (
                  <Select
                    native
                    label="Select Category"
                    {...field}
                    inputProps={{
                    name: 'type',
                    id: 'outlined-category-native-simple',
                    }}
                  >
                    <option value={null}>None</option>
                    {categoryList.map((option) => (
                    <option key={option.nameEn} value={option.type}>
                      {option.nameEn}
                    </option>
                    ))}
                  </Select>
                  )}
                />
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <div className={classes.orderLimitControl}>
                  <Controller
                    name="hasOrderLimit"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              type="checkbox"
                              color="primary"
                              checked={field.value}
                              {...field}
                            />
                          }
                          label="Order Limit"
                        />
                        {error && (
                          <FormHelperText>{error.message}</FormHelperText>
                        )}
                      </FormGroup>
                    )}
                  />
                  <Controller
                    name="orderLimit"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        type="number"
                        className={classes.textInput}
                        variant="outlined"
                        margin="dense"
                        defaultValue={field.value}
                        error={!!error}
                        helperText={error ? error.message : ""}
                        onKeyDown={(evt) =>
                          ["e", "E", "+", "-"].includes(evt.key) &&
                          evt.preventDefault()
                        }
                        {...field}
                      />
                    )}
                  />
                </div>
              </Grid>
            </Grid>

            <Grid container item xs={12}>
              <Box
                fontWeight={900}
                fontSize={13}
                mt={2}
                mb={2}
                ml={2}
                width="100%"
              >
                <Typography variant="p">Tag</Typography>
              </Box>
              <Controller
                defaultValue={[]}
                name="productTabIds"
                control={control}
                render={({
                  field: { onChange, value, ...rest },
                  fieldState: { error },
                }) => {
                  return (
                    <Autocomplete
                      multiple
                      fullWidth
                      label="Tag"
                      options={productTagList}
                      disabled={disabled}
                      getOptionSelected={(option, value) =>
                        option.id === value.id
                      }
                      getOptionLabel={(option) => option.label}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Tag"
                          margin="dense"
                          placeholder="Tag"
                          error={!!error}
                          helperText={error ? error.message : ""}
                        />
                      )}
                      value={productTagList.filter((o) =>
                        productTag?.includes(o.id)
                      )}
                      onChange={(e, values) => {
                        console.log(values);
                        setValue(
                          "productTabIds",
                          values.map((item) => item.id)
                        );
                      }}
                      {...rest}
                    />
                  );
                }}
              />
            </Grid>

          

            {/*Product Options*/}
              <Grid container item xs={12}>
                <Box
                  fontWeight={900}
                  fontSize={13}
                  mt={2}
                  mb={1}
                  ml={2}
                  width="100%"
                >
                  <Typography variant="p">Product Options</Typography>
                </Box>

                <Grid item xs={6}>
                  <Controller
                    name={`options.nameEn`}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        label="Option Name (English)"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        defaultValue={field.value}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={6}>
                  <Controller
                    name={`options.nameTc`}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <TextField
                        label="Option Name (Traditional Chinese)"
                        variant="outlined"
                        margin="dense"
                        className={classes.textInput}
                        fullWidth
                        {...field}
                        defaultValue={field.value}
                        error={!!error}
                        helperText={error ? error.message : ""}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12}>
                  <ProductOptionSections
                    getValues={getValues}
                    setValue={setValue}
                    control={control}
                    disabled={disabled}
                  />
                </Grid>
              </Grid>

            <Box
              fontWeight={900}
              fontSize={13}
              mt={2}
              mb={1}
              ml={2}
              width="100%"
            >
              <Typography variant="p">Shipping Method</Typography>
            </Box>
            <Grid item xs={12} container direction="vertical" spacing={3}>

              <Grid item xs={4}>
                <Controller
                  control={control}
                  name="isMailDelivery"
                  render={({
                    field: { value, onChange, ...rest },
                    fieldState: { error },
                  }) => (
                    <ToggleButtonGroup
                      {...rest}
                      value={value}
                      onChange={(event, newFormats) => {
                        if (newFormats !== null) {
                          onChange(newFormats);
                        }
                      }}
                      exclusive
                      aria-label="Shipping Method"
                      className={classes.input}
                    >
                      <ToggleButton
                        value={false}
                        aria-label="Collect in person"
                        style={{ width: "50%" }}
                      >
                        Collect in person
                      </ToggleButton>
                      <ToggleButton
                        value={true}
                        aria-label="Delivery by mail"
                        style={{ width: "50%" }}
                      >
                        Delivery by mail
                      </ToggleButton>
                    </ToggleButtonGroup>
                  )}
                />
              </Grid>
            </Grid>


            <Box
              fontWeight={900}
              fontSize={13}
              mt={2}
              mb={1}
              ml={2}
              width="100%"
            >
              <Typography variant="p">Product Images</Typography>
            </Box>
            <Grid container item xs={12} direction="column">
              <Controller
                name="image.image"
                control={control}
                render={({ field, fieldState: { error } }) => {
                  return (
                    <Grid item xs={12}>
                      <div className={classes.imageGallery}>
                        <div className={classes.imageGalleryBlk}>
                          {field.value && field.value.map((slide) => {
                            return (
                              <div className={classes.imgPreview} key={slide}>
                                <img src={slide} alt={slide} />
                                {disabled || (
                                  <IconButton
                                    type="button"
                                    onClick={() => removeImgFromSlides(slide)}
                                  >
                                    <Cancel />
                                  </IconButton>
                                )}
                              </div>
                            );
                          })}
                        </div>
                        {disabled || (
                          <div className={classes.imageGalleryControl}>
                            <input
                              style={{ display: "none" }}
                              id="upload-image"
                              type="file"
                              onChange={handleFileUpload}
                              multiple
                            />
                            <Button
                              component="label"
                              htmlFor="upload-image"
                              variant="contained"
                              disableElevation
                              style={{
                                color: "white",
                                background: "#306F9D",
                                margin: "0px",
                                padding: "9px 16px",
                              }}
                            >
                              Add to Gallery
                            </Button>
                          </div>
                        )}
                      </div>
                    </Grid>
                  );
                }}
              />
            </Grid>




            <Grid item xs={12} container direction="vertical" spacing={3}>
              <Grid item xs={4}>
                <Controller
                  control={control}
                  name="status"
                  render={({
                    field: { value, onChange, ...rest },
                    fieldState: { error },
                  }) => (
                    <ToggleButtonGroup
                      {...rest}
                      value={value}
                      onChange={(event, newFormats) => {
                        if (newFormats !== null) {
                          onChange(newFormats);
                        }
                      }}
                      exclusive
                      aria-label="Status"
                      className={classes.input}
                    >
                      <ToggleButton
                        value={"ACTIVE"}
                        aria-label="Active"
                        style={{ width: "50%" }}
                      >
                        Active
                      </ToggleButton>
                      <ToggleButton
                        value={"INACTIVE"}
                        aria-label="Inactive"
                        style={{ width: "50%" }}
                      >
                        Inactive
                      </ToggleButton>
                    </ToggleButtonGroup>
                  )}
                />
              </Grid>
            </Grid>
          </Box>


          {disabled || (
            <div className={classes.buttonGroup}>
              <Button
                type="submit"
                variant="contained"
                disableElevation
                style={{
                  color: "white",
                  background: "#306F9D",
                  marginRight: "5px",
                  padding: "9px 16px",
                }}
              >
                {id === 'new' ? 'Create' : 'Save Changes'}
              </Button>
            </div>
          )}
        </fieldset>
      </form>
    </div>
  )
}

export default ProductEditPage;